import { Fragment, useContext } from 'react';
import { Placeholder } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { COMMON_CURRENCY_PRECISION } from 'components/constants';
import i18nContext from 'components/i18n-context';
import { formatDate, formatMoney } from 'services/utils';
import './ReconciliationReportsTableRow.scss';

const ReconciliationReportsTableRow = ({ isLoading, reconciliationReportData }) => {
  const i18n = useContext(i18nContext);

  const getReconciliationReportInfoBlock = (reconciliationReportBlockInfo) => {
    if (isLoading) {
      return (
        <Placeholder as={'p'} animation={'glow'}>
          <Placeholder className={'reconciliation-reports-loader-placeholder'} xs={12} bg={'secondary'} />
        </Placeholder>
      );
    } else if (Array.isArray(reconciliationReportBlockInfo)) {
      return (
        <p>
          {reconciliationReportBlockInfo.map((item, index) => {
            if (item) {
              return (
                <Fragment key={index}>
                  {item}
                  {index < reconciliationReportBlockInfo?.length - 1 && <br />}
                </Fragment>
              );
            }
          })}
        </p>
      );
    } else {
      return <p>{reconciliationReportBlockInfo}</p>;
    }
  };

  return (
    <tr>
      <td className={'reconciliation-reports-table-cell'}>
        {getReconciliationReportInfoBlock(formatDate(reconciliationReportData.reportDate))}
      </td>
      <td className={'reconciliation-reports-table-cell'}>
        {getReconciliationReportInfoBlock(
          i18n.getMessage(`paymentProvider.${reconciliationReportData.transferProvider}`)
        )}
      </td>
      <td className={'reconciliation-reports-table-cell'}>
        {getReconciliationReportInfoBlock(reconciliationReportData.currency)}
      </td>
      <td className={'reconciliation-reports-table-cell'}>
        {getReconciliationReportInfoBlock(
          formatMoney(reconciliationReportData.closingTransitAccountBalance, COMMON_CURRENCY_PRECISION)
        )}
      </td>
      <td className={'reconciliation-reports-table-cell'}>
        {getReconciliationReportInfoBlock(
          formatMoney(reconciliationReportData.closingCommissionAccountBalance, COMMON_CURRENCY_PRECISION)
        )}
      </td>
      <td className={'reconciliation-reports-table-cell'}>
        {getReconciliationReportInfoBlock(
          formatMoney(reconciliationReportData.closingCustomerAccountsTotal, COMMON_CURRENCY_PRECISION)
        )}
      </td>
      <td className={'reconciliation-reports-table-cell'}>
        {getReconciliationReportInfoBlock(
          formatMoney(reconciliationReportData.incomingTransactionsTotal, COMMON_CURRENCY_PRECISION)
        )}
      </td>
      <td className={'reconciliation-reports-table-cell'}>
        {getReconciliationReportInfoBlock(
          formatMoney(reconciliationReportData.incomingExchangesTotal, COMMON_CURRENCY_PRECISION)
        )}
      </td>
      <td className={'reconciliation-reports-table-cell'}>
        {getReconciliationReportInfoBlock(
          formatMoney(reconciliationReportData.outgoingTransactionsTotal, COMMON_CURRENCY_PRECISION)
        )}
      </td>
      <td className={'reconciliation-reports-table-cell'}>
        {getReconciliationReportInfoBlock(
          formatMoney(reconciliationReportData.outgoingExchangesTotal, COMMON_CURRENCY_PRECISION)
        )}
      </td>
      <td className={'reconciliation-reports-table-cell'}>
        {getReconciliationReportInfoBlock(
          formatMoney(reconciliationReportData.commissionsTotal, COMMON_CURRENCY_PRECISION)
        )}
      </td>
    </tr>
  );
};

ReconciliationReportsTableRow.propTypes = {
  isLoading: PropTypes.bool,
  reconciliationReportData: PropTypes.oneOfType([
    PropTypes.shape({
      reportDate: PropTypes.string,
      transferProvider: PropTypes.string,
      currency: PropTypes.string,
      closingTransitAccountBalance: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      closingCommissionAccountBalance: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      closingCustomerAccountsTotal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      incomingTransactionsTotal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      incomingExchangesTotal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      outgoingTransactionsTotal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      outgoingExchangesTotal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      commissionsTotal: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }),
    PropTypes.oneOf([null])
  ])
};

export default ReconciliationReportsTableRow;
